import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import store from "../../../store";

class MyContentTask extends AbstractRequestTask {

  constructor(filterlist = '') {
    super();
    const user = store.getState().user;
    this._filterlist = filterlist;
    this.lasttouch = user && user.lasttouch && user.lasttouch.favorited ? user.lasttouch.favorited : false;
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/user/v1/favorited`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    const filterlist = this._filterlist;
    const lasttouch = this.lasttouch;

    return Object.assign({}, params, { filterlist, lasttouch });
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default MyContentTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/MyContentTask.js